<template>
  <WorkBenchSequenceWaggonWorkPackage>
    <template #content>
      <transition name="dialog_slide">
        <router-view style="z-index: 20"/>
      </transition>
      <!-- Attributes -->

    <StandardFlexBox
      class="pt-1 pr-1 pb-1"
      height="100%"
      width="calc(100% / 3)"
      style="z-index: 10"
      >
      <WorkBenchWorkPackage
        :color="work_package.color"
        :text_color="work_package.textcolor"
        no_header="true"
        >
        <template #content>
          <StandardDataField
            placeholder="description"
            width="100%"
            flat="true"
            :resizable="true"
            :text_color="work_package.textcolor"
            :value="work_package.description"
            readonly="true"
          />
          <v-divider :color="work_package.textcolor" width="100%"/>
          <StandardFlexBox>
          <!-- attributes planned -->
          <StandardFlexBox
            class="pa-1"
            width="100%"
            direction="column"
            >
            {{$t('Project.Workpackage.Info.AttributesPlanned')}}
            <StandardFlexBox>
              <StandardDataField
              :value="work_package.time_effort_planned"
              :readonly="read_only"
              icon="speed"
              width="28%"
              :text_color="work_package.textcolor"
              :type="'number'"
              @click.native="
                updateWBLObject({
                  path: [
                    {sequence_editor_variables: 'statistic_settings'}
                  ],
                  update: {
                    value: 'time_effort_planned'
                  }
                })
              "
              @changeValue="
                create?
                updateWBLObject({
                  path: [
                    {sequence: ''},
                    {swaggons: waggon_id},
                    {sworkpackages: work_package_id}
                  ],
                  update: {
                    time_effort_planned: parseFloat(parseFloat($event).toFixed(2))
                  },
                })
                :
                updateWBObject({
                  url: [
                    {[`${prefix}sequences`]: sequence_id},
                    {[`${prefix}swaggons`]: waggon_id},
                    {[`${prefix}sworkpackages`]: work_package_id}
                  ],
                  update: {
                    time_effort_planned: parseFloat(parseFloat($event).toFixed(2))
                  }
                })
                "
              />
              <div style="width: 8%; line-height: 33px; text-align: center;">/</div>
              <StandardDataField
                :value="work_package.manpower_planned"
                :readonly="read_only"
                icon="accessibility"
                width="28%"
                :text_color="work_package.textcolor"
                :type="'number'"
                @click.native="
                  updateWBLObject({
                    path: [
                      {sequence_editor_variables: 'statistic_settings'}
                    ],
                    update: {
                      value: 'manpower_planned'
                    }
                  })
                "
                @changeValue="
                  create?
                  updateWBLObject({
                    path: [
                      {sequence: ''},
                      {swaggons: waggon_id},
                      {sworkpackages: work_package_id}
                    ],
                    update: {
                      manpower_planned: parseFloat(parseFloat($event).toFixed(2))
                    },
                  })
                  :
                  updateWBObject({
                    url: [
                      {[`${prefix}sequences`]: sequence_id},
                      {[`${prefix}swaggons`]: waggon_id},
                      {[`${prefix}sworkpackages`]: work_package_id}
                    ],
                    update: {
                      manpower_planned: parseFloat(parseFloat($event).toFixed(2))
                    }
                  })"
                />
              <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
              <StandardDataField
                :value="work_package.manpower_planned === 0 || isNaN(Math.round((work_package.time_effort_planned/work_package.manpower_planned)*100) / 100)?
                        '':Math.round((work_package.time_effort_planned/work_package.manpower_planned)*100) / 100"
                icon="timer"
                width="28%"
                :text_color="work_package.textcolor"
                :readonly="true"
                @click.native="
                updateWBLObject({
                  path: [
                    {sequence_editor_variables: 'statistic_settings'}
                  ],
                  update: {
                    value: 'duration_planned'
                  }
                })
                "
                />
            </StandardFlexBox>
            <StandardFlexBox>
              <StandardDataField
                :value="work_package.quantity_value"
                :readonly="read_only"
                icon="drag_indicator"
                width="33%"
                :text_color="work_package.textcolor"
                :type="'number'"
                @changeValue="
                  create?
                  updateWBLObject({
                    path: [
                      {sequence: ''},
                      {swaggons: waggon_id},
                      {sworkpackages: work_package_id}
                    ],
                    update: {
                      quantity_value: parseInt($event)
                    },
                  })
                  :
                  updateWBObject({
                    url: [
                      {[`${prefix}sequences`]: sequence_id},
                      {[`${prefix}swaggons`]: waggon_id},
                      {[`${prefix}sworkpackages`]: work_package_id}
                    ],
                    update: {
                      quantity_value: parseInt($event)
                    }
                  })"
                />
              <StandardDataField
                :value="work_package.quantity_unit"
                :readonly="read_only"
                icon="drag_indicator"
                width="33%"
                :text_color="work_package.textcolor"
                @changeValue="
                  create?
                  updateWBLObject({
                    path: [
                      {sequence: ''},
                      {swaggons: waggon_id},
                      {sworkpackages: work_package_id}
                    ],
                    update: {
                      quantity_unit: $event
                    },
                  })
                  :
                  updateWBObject({
                    url: [
                      {[`${prefix}sequences`]: sequence_id},
                      {[`${prefix}swaggons`]: waggon_id},
                      {[`${prefix}sworkpackages`]: work_package_id}
                    ],
                    update: {
                      quantity_unit: $event
                    }
                  })"
                />
            </StandardFlexBox>
          </StandardFlexBox>
          </StandardFlexBox>
        </template>
      </WorkBenchWorkPackage>
    </StandardFlexBox>
    <!-- Steps -->
    <StandardFlexBox
      class="pt-1 pb-1 overflow-hidden"
      height="100%"
      width="calc(100% / 3)"
      no_wrap="true"
      style="z-index: 10"
      >
      <WorkBenchWorkPackage
        :tabs="true"
        :color="work_package.color"
        :text_color="work_package.textcolor"
        >
        <template #header>
          <WorkBenchWorkPackageTab
            v-for="(type, index) in [`${prefix}slogisticsteps`, `${prefix}sdesignsteps`, `${prefix}sworksteps`, `${prefix}squalitysteps`, `${prefix}sdefectsteps`, `${prefix}shandoversteps`, `${prefix}smaterialsteps`, `${prefix}smachinesteps`]"
            :key="type"
            :tab="{
              icon: ['truck-container', 'crossed-pencil-ruler', 'person-helmet', 'speech-bubble-check', 'fragile', 'handshake', 'wall-brick', 'crane'][index],
              text: `${selected_step_type.substring(`${prefix}${prefix_two_step}`.length, selected_step_type.length-5).toUpperCase()}.steps`,
              type: `${type.substring(`${prefix}${prefix_two_step}`.length, type.length-5).toUpperCase()}.steps`
              }"
            :width="selected_step_type === type?'calc(100% - 250px)':'50px'"
            :selected="selected_step_type === type?true:false"
            :color="work_package.color"
            :text_color="work_package.textcolor"
            :disabled="!checkStepPermission(type)"
            @mousedown.native.prevent.stop="switchStepTab(type),
              updateWBLObject({
                path: [
                  {sequence_editor_variables: 'statistic_settings'}
                ],
                update: {
                  value: `${type.substring(prefix.length)}_count`
                }
              })
              "
            />
        </template>
        <template #content>
          <StandardFlexBox
            ref="step_flex_box"
            width="100%"
            height="calc(100% - 25px)"
            direction="column"
            >
            <template v-if="work_package[selected_step_type].length !== 0">
              <StandardStep
                v-for="(step, index) in (create?work_package[selected_step_type]:getWBObjects({type: selected_step_type, ids: work_package[selected_step_type]}))"
                :key="selected_step_type + create?index:step.id"
                :step="step"
                :step_type="selected_step_type.includes('worksteps')?'worksteps':(selected_step_type.includes('machinesteps')?'machinesteps':'othersteps')"
                :location="selected_step_type.includes('worksteps') || selected_step_type.includes('machine')? 'taktplan_edit' : ''"
                :color="work_package.color"
                :text_color="work_package.textcolor"
                :readonly="true"
                width="100%"
              />
            </template>
          </StandardFlexBox>
        </template>
      </WorkBenchWorkPackage>
    </StandardFlexBox>
    <!-- More  -->
    <StandardFlexBox
      class="pt-1 pb-1 pl-1 overflow-hidden"
      height="100%"
      width="calc(100%/3)"
      no_wrap="true"
      style="z-index: 10"
      >
      <WorkBenchWorkPackage
        :tabs="true"
        :color="work_package.color"
        :text_color="work_package.textcolor"
        >
        <template #header>
          <WorkBenchWorkPackageTab
            v-for="(type, index) in ['costs', 'attachements']"
            :key="type"
            :tab="{
              icon: ['money', 'image'][index],
              text: selected_more_type.toUpperCase(),
              type: type.toUpperCase()
              }"
            :width="selected_more_type === type?'calc(100% - 50px)':'50px'"
            :selected="selected_more_type === type?true:false"
            :color="work_package.color"
            :text_color="work_package.textcolor"
            @mousedown.native.prevent.stop="
              selected_more_type = type,
              updateWBLObject({
                path: [
                  {sequence_editor_variables: 'statistic_settings'}
                ],
                update: {
                  value: type === 'costs'?'costs_budget_labour':'sworkpackageimages_count'
                }
              })
              "
            />
        </template>
        <template #content>
          <template v-if="selected_more_type === 'costs'">
            <!-- Legende -->
            <StandardFlexBox width="100%" height="30px">
              <StandardDataField
                width="20%"
                flat="true"
                :readonly="true"
                />
                <div class="ml-3 mr-2"/>
              <StandardDataField
                width="20%"
                :value="$t('Project.Workpackage.Costs.WorkBenchEditor.Labour')"
                icon="accessibility"
                :text_color="work_package.textcolor"
                :readonly="true"
                />
              <div class="ml-2 mr-2">+</div>
              <StandardDataField
                width="20%"
                :value="$t('Project.Workpackage.Costs.WorkBenchEditor.Material')"
                icon="view_module"
                :text_color="work_package.textcolor"
                :readonly="true"
                />
              <div class="ml-2 mr-2">=</div>
              <StandardDataField
                width="20%"
                value="     +"
                icon="accessibility"
                :text_color="work_package.textcolor"
                append_icon="view_module"
                :readonly="true"
                />
            </StandardFlexBox>
            <StandardFlexBox width="100%">
              <StandardDataField
                width="20%"
                :value="$t('Project.Workpackage.Costs.Budget')"
                icon="account_balance_wallet"
                :text_color="work_package.textcolor"
                :readonly="true"
                />
                <div class="ml-3 mr-2"/>
              <StandardDataField
                width="20%"
                :text_color="work_package.textcolor"
                :value="work_package.costs_budget_labour"
                :readonly="read_only"
                :type="'number'"
                @click.native="
                  updateWBLObject({
                    path: [
                      {sequence_editor_variables: 'statistic_settings'}
                    ],
                    update: {
                      value: 'costs_budget_labour'
                    }
                  })
                "
                @changeValue="
                  create?
                  updateWBLObject({
                    path: [
                      {sequence: ''},
                      {swaggons: waggon_id},
                      {sworkpackages: work_package_id}
                    ],
                    update: {
                      costs_budget_labour: parseInt($event)
                    },
                  })
                  :
                  updateWBObject({
                    url: [
                      {[`${prefix}sequences`]: sequence_id},
                      {[`${prefix}swaggons`]: waggon_id},
                      {[`${prefix}sworkpackages`]: work_package_id}
                    ],
                    update: {
                      costs_budget_labour: parseInt($event)
                    }
                  })"
                />
                <div class="ml-2 mr-2">+</div>
              <StandardDataField
                  width="20%"
                  :text_color="work_package.textcolor"
                  :value="work_package.costs_budget_material"
                  :readonly="read_only"
                  :type="'number'"
                  @click.native="
                    updateWBLObject({
                      path: [
                        {sequence_editor_variables: 'statistic_settings'}
                      ],
                      update: {
                        value: 'costs_budget_material'
                      }
                    })
                  "
                  @changeValue="
                    create?
                    updateWBLObject({
                      path: [
                        {sequence: ''},
                        {swaggons: waggon_id},
                        {sworkpackages: work_package_id}
                      ],
                      update: {
                        costs_budget_material: parseInt($event)
                      },
                    })
                    :
                    updateWBObject({
                      url: [
                        {[`${prefix}sequences`]: sequence_id},
                        {[`${prefix}swaggons`]: waggon_id},
                        {[`${prefix}sworkpackages`]: work_package_id}
                      ],
                      update: {
                        costs_budget_material: parseInt($event)
                      }
                    })"
                  />
                <div class="ml-2 mr-2">=</div>
              <StandardDataField
                width="20%"
                :text_color="work_package.textcolor"
                :value="parseInt(work_package.costs_budget_labour) + parseInt(work_package.costs_budget_material)"
                :readonly="true"
                />
            </StandardFlexBox>
          </template>
          <template v-if="selected_more_type === 'attachements'">
            <StandardFlexBox
              ref="image_flex_box"
              direction="column"
              height="calc(100% - 33px)"
              :no_wrap="true"
              >
              <template v-if="work_package[`${prefix}sworkpackageimages`].length !== 0">
                <StandardDataField
                  v-for="(image, index) in (create?work_package[`${prefix}sworkpackageimages`]:getWBObjects({type: `${prefix}sworkpackageimages`, ids: work_package[`${prefix}sworkpackageimages`]}))"
                  :key="create?index:image.id"
                  :image="create?image.local_url:image.image"
                  :header="create?'':`${image.created.substring(0, 19)}`"
                  :value="image.comment"
                  :readonly="true"
                  :text_color="work_package.textcolor"
                  width="100%"
                  @clickImage="$router.push({
                    name: `${location}SequenceWaggonWorkPackageImagesZoomImage`,
                    params: {
                      image_id: create?index:image.id,
                    }
                  })"
                />
              </template>
            </StandardFlexBox>
          </template>
        </template>
      </WorkBenchWorkPackage>
    </StandardFlexBox>
    </template>
  </WorkBenchSequenceWaggonWorkPackage>
</template>
<script>
  import store from '@/store/index';
  import { WorkBenchWorkPackageMixin } from '@/mixins/WorkBenchWorkPackage.mixin.js'
import { mapGetters } from 'vuex';
  export default {
    props: [
      'sequence_id',
      'waggon_id',
      'work_package_id',
      'create',
      'prefix_two',
      'location',
      'read_only'
    ],
    mixins: [
      WorkBenchWorkPackageMixin,
    ],
    data: () => ({
    }),
    created() {
    },
    beforeRouteUpdate: (to, from, next) => {
      if (to.params.sequence_id !== 'create') {
        let prefix = '';
        switch (to.params.template_type) {
          case 'custom':
            break;
          case 'company':
            prefix = 'b';
            break;
          case 'community':
            prefix = 'c';
            break;
        }
        if (to.params.template_type === 'company') {
          store.dispatch('WorkBench/requestWBObject', {
            url: [
              {[`bsequences`]: to.params.sequence_id},
              {[`bswaggons`]: to.params.waggon_id},
              {[`bsworkpackages`]: to.params.workpackage_id},
              {showWithEntitiesNormalized: ''}
            ],
            template_type: to.params.template_type
          }).then(() => next())
        } else {
          store.dispatch('WorkBench/requestWBObject', {
            url: [
              {[`${prefix}sequences`]: to.params.sequence_id},
              {[`${prefix}swaggons`]: to.params.waggon_id},
              {[`${prefix}sworkpackages`]: to.params.workpackage_id},
              {showWithEntitiesNormalized: ''}
            ],
            template_type: to.params.template_type
          }).then(() => next())
        }
      } else {
        next();
      }
    },
    computed: {
      ...mapGetters('Auth', [
        'hasPermission'
      ])
    },
    methods: {
      checkStepPermission(type){
        let actual_type = type.substring(`${this.prefix_one_step}${this.prefix_two_step}`.length, type.length-5);
        let permission_name = `${this.prefix_one_step.toUpperCase()}${this.prefix_two_step.toUpperCase()}${actual_type.charAt(0).toUpperCase()}${actual_type.slice(1)}Step READ`;
        let permission = this.hasPermission(permission_name);
        return permission;
      },
      switchStepTab(type){
        if (this.checkStepPermission(type)) {
          this.bottom_bar.content = type; 
          this.selected_step_type = type; 
          if (this.bottom_bar.show){
            this.add_step = true;
          }
        }
      },
    }
  }
</script>
